'use client';
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import { toast } from 'react-toastify';
import './listBusiness.css';
import { useState, useEffect, useRef } from 'react';
import "../post-job/PostJob.css";
import businessApi from "../../services/businessApi";
import { IoCaretDownSharp } from "react-icons/io5";
import ConfirmModal from "../../components/ConfirmModal/ConfirmModal";
import modalTexts from '../../config/modalTexts.json';
import strings from "../../config/App.json";
import '../blogs/[category]/Blogs.css';
import '../einbuergerungstest/ToolDetailsPage.css';
import '../job-board/JobBoard.css';
import '../contact/Contact.css';
import '../../components/SearchBar/SearchBar.css';
import '../einbuergerungstest/mocktest/bavaria/StateSelection.css';
import '../job-board/Components/FilterPanel.css';
import { SlClose } from "react-icons/sl";
import BusinessServicesSelector from "../business-listings/Components/BusinessServicesSelector";
import contactApi from "@/services/contactApi";

export default function ListBusiness() {

    const [isSubmitted, setIsSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [selectedServices, setselectedServices] = useState([]);
    const [services, setservices] = useState([]);
    const [openDropdown, setOpenDropdown] = useState(null);
    const panelRef = useRef(null);
    const [isCancelModalOpen, setCancelModalOpen] = useState(false);
    const [logoFile, setLogoFile] = useState(null);
    const [businessCategories, setBusinessCategories] = useState([]);
    const [resetKey, setResetKey] = useState(0);

    const [formData, setFormData] = useState({
        business_name: "",
        address1: "",
        address2: "",
        city: "",
        state: "",
        postal_code: "",
        country: "",
        email: "",
        contactNo: "",
        url: "",
        categoryId: "",
        categoryName: "",
        services: [],
        logo: "",
    });

    useEffect(() => {
        const loadCategories = async () => {
            try {
                const res = await businessApi.getCategories();
                if (res?.success && Array.isArray(res?.data)) {
                    setBusinessCategories(res.data);
                } else {
                    toast.error("Failed to load categories");
                }
            } catch {
                toast.error("Error loading categories");
            }
        };
        loadCategories();
    }, []);

    useEffect(() => {
        const fetchServices = async () => {
            try {
                if (!formData.categoryId) {
                    const res = await businessApi.getServices();
                    const data = res?.data ?? res;
                    setservices(Array.isArray(data) ? data : []);
                    return;
                }

                const res = await businessApi.getServicesByCategory(formData.categoryId);
                const data = res?.data ?? res;
                setservices(Array.isArray(data) ? data : []);
            } catch (err) {
                console.error("Error loading services:", err);
                setservices([]);
            }
        };

        fetchServices();
    }, [formData.categoryId]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (panelRef.current && !panelRef.current.contains(event.target)) {
                setOpenDropdown(null);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const resetForm = () => {
        setResetKey(prev => prev + 1);
        setFormData({
            business_name: "",
            address1: "",
            address2: "",
            city: "",
            state: "",
            postal_code: "",
            country: "",
            email: "",
            contactNo: "",
            url: "",
            categoryId: "",
            categoryName: "",
            services: [],
            logo: "",
        });
        setselectedServices([]);
        setservices([]);
        setLogoFile(null);
        setOpenDropdown(null);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        let finalUrl = formData.url?.trim();
        if (finalUrl) {
            if (!finalUrl.startsWith("http://") && !finalUrl.startsWith("https://")) {
                finalUrl = "https://" + finalUrl;
            }
        }

        if (!formData.business_name.trim()) return toast.error("Business name is required");
        if (!formData.categoryId) return toast.error("Please select a business category");
        if (!selectedServices || selectedServices.length === 0) {
            return toast.error("Please select at least one business service");
        }
        if (!formData.country.trim()) return toast.error("Country is required");

        setLoading(true);

        try {
            const payload = {
                business_name: formData.business_name,
                address1: formData.address1,
                address2: formData.address2,
                city: formData.city,
                state: formData.state,
                postal_code: formData.postal_code,
                country: formData.country,
                sender_email: formData.email,
                contact_no: formData.contactNo,
                website_url: finalUrl,
                categories: formData.categoryName ? [String(formData.categoryName)] : [],
                services: selectedServices.length > 0 ? selectedServices.map(s => String(s)) : [],
                logo: logoFile
            };

            const res = await businessApi.createBusiness(payload);

            if (res?.success) {
                const businessDetails = res.data;

                const normalize = (val) => {
                    if (!val) return [];
                    if (Array.isArray(val) && val.length === 1 && typeof val[0] === "string") {
                        try {
                            const parsed = JSON.parse(val[0]);
                            if (Array.isArray(parsed)) return parsed;
                        } catch (e) { }
                    }
                    return Array.isArray(val) ? val : [val];
                };

                const emailBody = {
                    source_record_id: businessDetails.source_record_id,
                    logo: businessDetails.logo,
                    business_name: businessDetails.business_name,
                    categories: normalize(businessDetails.categories).length ? normalize(businessDetails.categories) : (formData.categoryName ? [formData.categoryName] : []),
                    services: normalize(businessDetails.services).length ? normalize(businessDetails.services) : selectedServices,
                    address1: businessDetails.address1,
                    address2: businessDetails.address2,
                    city: businessDetails.city,
                    state: businessDetails.state,
                    postal_code: businessDetails.postal_code,
                    country: businessDetails.country,
                    sender_email: businessDetails.sender_email,
                    contact_no: businessDetails.contact_no,
                    website_url: businessDetails.website_url,
                    approval_link: businessDetails.approval_link,
                    rejection_link: businessDetails.rejection_link,
                    sponsor_approval_link: businessDetails.sponsor_approval_link,
                    sponsor_rejection_link: businessDetails.sponsor_rejection_link
                };
                console.log(emailBody);

                await contactApi.BusinessRequest(emailBody);

                toast.success("Business listing submitted successfully!");
                setIsSubmitted(true);
                resetForm();
            } else {
                toast.error(res?.message || "Submission failed");
            }
        } catch (err) {
            console.error("Submit error:", err?.response?.data || err);
            toast.error("Something went wrong");
        }

        setLoading(false);
    };

    return (
        <>
            <Header />
            <div className="job-content">
                <div className="background-ellipses">
                    <div className="ellipse ellipse-1"></div>
                    <div className="ellipse ellipse-2"></div>
                </div>

                <div className="page-container">
                    {!isSubmitted && (<>
                        <h1 className="Job_title" id="Post_job_title">List your business on Munich Indians</h1>
                        <p className="Job_des" id="Post_job_des">List your service in Munich</p>
                    </>)}

                    <div className="Post-Job-container">
                        {isSubmitted ? (
                            <div className="response-received">
                                <h2 className='Contact-Header'>Thank you! 🙂</h2>
                                <br />
                                <p className='thanksMsg'>We’ve received your details.<br />Our team will verify and then list your business.</p>
                            </div>
                        ) : (
                            <form className="contact-form" onSubmit={handleSubmit} ref={panelRef}>
                                <h2 className='Contact-Header'>Tell us about your business</h2>

                                <div className='form-flex'>
                                    <div className="form-group">
                                        <label>Business Name<span className="text-style-1">*</span></label>
                                        <input
                                            type="text"
                                            name="business_name"
                                            value={formData.business_name}
                                            onChange={handleChange}
                                            placeholder='Business Name'
                                            required
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Business Category<span className="text-style-1">*</span></label>
                                        <div
                                            className="custom-dropdown_filter"
                                            onClick={() =>
                                                setOpenDropdown(openDropdown === "categories" ? null : "categories")
                                            }
                                        >
                                            <div className="custom-dropdown-selected">
                                                {formData.categoryName || "Select"}
                                                <IoCaretDownSharp
                                                    className={`dropdown-arrow ${openDropdown === "categories" ? "rotate" : ""}`}
                                                />
                                            </div>

                                            {openDropdown === "categories" && (
                                                <div className="custom-dropdown-options">
                                                    {businessCategories.map((option) => (
                                                        <div
                                                            key={option.id}
                                                            className="custom-dropdown-option"
                                                            onClick={() => {
                                                                setFormData((prev) => ({
                                                                    ...prev,
                                                                    categoryId: option.id,
                                                                    categoryName: option.name
                                                                }));
                                                                setOpenDropdown(null);
                                                            }}
                                                        >
                                                            {option.name}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label>Business Logo</label>
                                    <label className="selected-tags" id="upload-bar">
                                        <span className="tag-chip" id="choose-btn">Choose File</span>
                                        <input
                                            type="file"
                                            accept=".png, .jpg, .jpeg, .svg, .webp"
                                            hidden
                                            onChange={(e) => {
                                                const file = e.target.files && e.target.files[0];
                                                e.target.value = "";
                                                if (!file) return;

                                                const allowed = ["image/png", "image/jpeg", "image/jpg", "image/svg+xml", "image/webp"];
                                                if (!allowed.includes(file.type)) {
                                                    toast.error("Only JPG, PNG, SVG, WEBP allowed.");
                                                    return;
                                                }

                                                setLogoFile(file);
                                            }}
                                        />

                                        <div className="upload_file">
                                            <span className="file-name">
                                                {logoFile ? logoFile.name : "No File Chosen"}
                                            </span>

                                            {logoFile && (
                                                <span className="remove-icon" onClick={() => setLogoFile(null)}>
                                                    <SlClose />
                                                </span>
                                            )}
                                        </div>
                                    </label>
                                </div>

                                <div className="form-group">
                                    <label>Services<span className="text-style-1">*</span></label>
                                    <BusinessServicesSelector
                                        tags={services.map((x) => x.name)}
                                        onChange={(services) => setselectedServices(services)}
                                        resetSignal={resetKey}
                                        required
                                    />
                                </div>

                                <div className="form-group">
                                    <label>Address Line 1<span className="text-style-1">*</span></label>
                                    <input
                                        type="text"
                                        name="address1"
                                        value={formData.address1}
                                        onChange={handleChange}
                                        placeholder="Address Line 1"
                                        required
                                    />
                                </div>

                                <div className="form-group">
                                    <label>Address Line 2</label>
                                    <input
                                        type="text"
                                        name="address2"
                                        value={formData.address2}
                                        onChange={handleChange}
                                        placeholder="Address Line 2"
                                    />
                                </div>
                                <div className='form-flex'>
                                    <div className="form-group">
                                        <label>City<span className="text-style-1">*</span></label>
                                        <input
                                            type="text"
                                            name="city"
                                            value={formData.city}
                                            onChange={handleChange}
                                            placeholder='City'
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>State<span className="text-style-1">*</span></label>
                                        <input
                                            type="text"
                                            name="state"
                                            value={formData.state}
                                            onChange={handleChange}
                                            placeholder="State"
                                            required
                                        />
                                    </div>
                                </div>
                                <div className='form-flex'>
                                    <div className="form-group">
                                        <label>Postal Code<span className="text-style-1">*</span></label>
                                        <input
                                            type="text"
                                            name="postal_code"
                                            value={formData.postal_code}
                                            onChange={handleChange}
                                            placeholder='Postal Code'
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label className="filter-label">Country<span className="text-style-1">*</span></label>
                                        <div
                                            className="custom-dropdown_filter"
                                            onClick={() =>
                                                setOpenDropdown(openDropdown === "Country" ? null : "Country")
                                            }
                                        >
                                            <div className="custom-dropdown-selected">
                                                {formData.country || "Select Country"}
                                                <IoCaretDownSharp
                                                    className={`dropdown-arrow ${openDropdown === "Country" ? "rotate" : ""}`}
                                                />
                                            </div>

                                            {openDropdown === "Country" && (
                                                <div className="custom-dropdown-options">
                                                    {["Germany", "India"].map((option, idx) => (
                                                        <div
                                                            key={idx}
                                                            className="custom-dropdown-option"
                                                            onClick={() =>
                                                                setFormData({ ...formData, country: option })
                                                            }
                                                        >
                                                            {option}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="form-flex">
                                    <div className="form-group">
                                        <label>Email</label>
                                        <input
                                            type="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            placeholder="Email"
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Contact No.</label>
                                        <input
                                            type="text"
                                            name="contactNo"
                                            value={formData.contactNo}
                                            onChange={handleChange}
                                            placeholder="Contact"
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label>Website URL</label>
                                        <input
                                            type="text"
                                            name="url"
                                            value={formData.url}
                                            onChange={handleChange}
                                            placeholder="Paste URL"
                                        />
                                    </div>
                                </div>

                                <div className="btnFlex">
                                    <button
                                        type="button"
                                        className="apply-btn"
                                        id="cancle-btn"
                                        onClick={() => setCancelModalOpen(true)}
                                    >
                                        Cancel
                                    </button>
                                    <button type="submit" disabled={loading} className="apply-btn">
                                        {loading ? "Posting..." : "Submit Listing"}
                                    </button>
                                </div>
                            </form>
                        )}
                    </div>
                </div>
            </div>

            <Footer />

            <ConfirmModal
                isOpen={isCancelModalOpen}
                title={modalTexts.cancel_List_Business.title}
                subtitle={modalTexts.cancel_List_Business.subtitle}
                confirmText={modalTexts.cancel_List_Business.confirmText}
                cancelText={modalTexts.cancel_List_Business.cancelText}
                onConfirm={() => {
                    resetForm();
                    toast.info("Form cleared");
                    setCancelModalOpen(false);
                    window.location.href = strings.BusinessListingPage;
                }}
                onCancel={() => setCancelModalOpen(false)}
            />
        </>
    );
}